import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleTour } from "../../reducers/tourSlice";
import './AIMbr.scss';
import ChatSection from "./components/ChatSection";
import PageTour from "../../components/PageTour/PageTour";
import MBRDashboard from "./components/MBRDashboard";
import { DragIndicatorOutlined } from "@mui/icons-material";
import { Button, Tooltip } from "antd";
import { WechatOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import {getTitleFromPath} from "../../libs/utilities/helpers/getTitle"
const AIMBR = () => {
  const dispatch = useDispatch();
  const chatInput = document.getElementsByClassName("chat-input");
  const tourState = useSelector((state) => state.tour);
  const [showHandAnimation, setShowHandAnimation] = useState(false);
  const [chatPosition, setChatPosition] = useState('inline');
  const [close, setClose] = useState(true);
  const location = useLocation();
  const [prevLeftWidth, setPrevLeftWidth] = useState(65);

  const [leftWidth, setLeftWidth] = useState(65);
  const [isDragging, setIsDragging] = useState(false);

  const containerRef = useRef(null);
  const dividerRef = useRef(null);

  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

   // Handle mouse move to resize
   const handleMouseMove = (e) => {
    if (!isDragging || !containerRef.current) return;
    
    const containerRect = containerRef.current.getBoundingClientRect();
    const containerWidth = containerRect.width;
    const mouseX = e.clientX - containerRect.left;
    
    const leftPixelWidth = mouseX;
    const rightPixelWidth = containerWidth - mouseX;
    
    if (leftPixelWidth < 400 || rightPixelWidth < 350) {
      return; // Don't resize if minimums aren't met
    }

    // Calculate new width percentage with constraints
    let newLeftWidth = (mouseX / containerWidth) * 100;
    
    // Add constraints (e.g., minimum 20% width for each pane)
    newLeftWidth = Math.max(20, Math.min(80, newLeftWidth));
    
    setLeftWidth(newLeftWidth);
  };

  // Stop dragging when mouse up
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const toggleChatPosition = () => {
    if (chatPosition === 'inline') {
      setPrevLeftWidth(leftWidth);
      setLeftWidth(100); // Expand left pane to full width
      setChatPosition('corner');
    } else {
      setLeftWidth(prevLeftWidth); // Restore previous left width
      setChatPosition('inline');
    }
  };

  useEffect(() => {
    let timeout;
    if (tourState.show) {
      timeout = setTimeout(() => {
        setShowHandAnimation(true);
      }, 1000);
    } else {
      setShowHandAnimation(false);
    }

    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }
    
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);

      clearTimeout(timeout);
    };

  }, [tourState, isDragging]);

  const handleInputFocus = () => {
    dispatch(toggleTour({ show: false }));
    setShowHandAnimation(false);
    chatInput[0].style.zIndex = "inherit";
  };


  const handleTourClose = () => {
    dispatch(toggleTour({ show: false }))
}

  return (
    <>
    <div className="heading-div">
        <p className="text5">
          {getTitleFromPath(location ?.pathname)}
        </p>
      </div>
    <div ref={containerRef} className="ai-mbr" style={{ cursor: isDragging ? 'col-resize' : 'auto'}}>
    
      <PageTour 
        show={tourState.show} 
        handleShow={handleTourClose} 
        target="chat-input" 
        title="Start Typing Your Prompt To See The Magic"  />

          <div  className="graphical" style={{ width: `${leftWidth}%` }}>
            <MBRDashboard /> 
          </div>
          
          {!close && chatPosition !== 'corner' && <div
              ref={dividerRef}
              onMouseDown={handleMouseDown}
              style={{ 
                touchAction: 'none',
                cursor: 'col-resize',
                padding: '0',
                display: "flex",
                alignItems: "center"
              }}
            >
            <DragIndicatorOutlined style={{ width: "21px", color: "gray" }} />
          </div>}

          <div className="chat-section" 
            handleInputFocus={handleInputFocus} 
            style={{  background: "transparent",
              position: chatPosition === 'corner' ? 'absolute' : 'initial',
              width: chatPosition === 'corner' ? '100%' : `${100 - leftWidth}%`,
              right: chatPosition === 'corner' ? '0' : 'auto',
              bottom: chatPosition === 'corner' ? '0' : 'auto',
              height: chatPosition === 'corner' ? '100%' : '100%',
              zIndex: chatPosition === 'corner' ? '50' : 'auto',
              display: close ? "none" : 'block'
            }}>
            <ChatSection 
              chatPosition={chatPosition}
              showTour={showHandAnimation} 
              style={{ width: `${100 - leftWidth}%` }}
              handleInputFocus={handleInputFocus}
              toggleChatPosition={toggleChatPosition}
              onChatClose={(e) => setClose(e)}
            />
          </div>


       {close && <div className="chat-button">
          <Tooltip title="Chat">
            <Button size="large" onClick={() => {setClose(false)}} shape="circle" style={{ background: "#005e9e" }}>
              <WechatOutlined style={{ color: "white", fontSize: "18px" }}  />
            </Button>
          </Tooltip>
        </div>}

    </div>
    </>
  );
};

export default AIMBR;
